import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import {
  CreateReferralPartnerInviteRequest,
  UpdateInviteReferralPartnerRequest,
} from '@/types/requests/invite-referral-partners'
import { InviteReferralPartnerItem } from '@/types/responses/invite-referral-partners'

class InviteReferralPartnerService {
  private endpoint = `${API_PATH_INTERNAL}/invite-referral-partners`

  async createInvite(
    request: CreateReferralPartnerInviteRequest,
  ): Promise<InviteReferralPartnerItem> {
    const response = await apiService.post<InviteReferralPartnerItem>(
      this.endpoint,
      request,
    )

    return response.data
  }

  async sendInviteReminder(inviteReferralPartnerId: number) {
    const response = await apiService.patch(
      `${this.endpoint}/${inviteReferralPartnerId}/remind`,
      {},
    )

    return response.data
  }

  async updateInvite(
    inviteReferralPartnerId: number,
    request: UpdateInviteReferralPartnerRequest,
  ) {
    const response = await apiService.patch(
      `${this.endpoint}/${inviteReferralPartnerId}`,
      request,
    )

    return response.data
  }

  async deleteInvite(inviteReferralPartnerId: number) {
    const response = await apiService.delete(
      `${this.endpoint}/${inviteReferralPartnerId}`,
    )

    return response.data
  }
}

const inviteReferralPartnerService = new InviteReferralPartnerService()

export default inviteReferralPartnerService
